import React from 'react';
import {AiOutlineCheckCircle} from '../assets/icons/vander'

export default function Checkmarks({ sectionId }) {
  const aboutData = [
    {
      id: 0,
      check1: 'Affordable Peace of Mind',
      check2: 'Flexible Protection',
      check3: 'Life-Proof Your Family'
    },
    {
      id: 1,
      check1: 'Financial Security for a Lifetime',
      check2: 'Guaranteed Peace of Mind',
      check3: 'Cash Value and Loan Options'
    },
    {
      id: 2,
      check1: 'Protect Your Independence',
      check2: 'Plan for the Unexpected',
      check3: 'Affordable Lifelong Care'
    },
    {
      id: 3,
      check1: 'Financial Freedom Ahead',
      check2: 'Grow Your Tomorrow',
      check3: 'Wealth, Step by Step'
    },
  ];

  // Filter the data based on the provided sectionId
  const filteredData = aboutData.filter(item => item.id === sectionId);

  return (
    <>
      {filteredData.map((item, index) => (
        <ul className="list-unstyled text-muted mb-0" key={index}>
          <li className="mb-0">
            <span className="text-dark h5 me-2">
              <AiOutlineCheckCircle className="align-middle" />
            </span>
            {item.check1}
          </li>
          <li className="mb-0">
            <span className="text-dark h5 me-2">
              <AiOutlineCheckCircle className="align-middle" />
            </span>
            {item.check2}
          </li>
          <li className="mb-0">
            <span className="text-dark h5 me-2">
              <AiOutlineCheckCircle className="align-middle" />
            </span>
            {item.check3}
          </li>
        </ul>
      ))}
    </>
  );
}
